<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.75 8C20.1642 8 20.5 8.32893 20.5 8.73469L20.5 31.2653C20.5 31.6711 20.1642 32 19.75 32C19.3358 32 19 31.6711 19 31.2653L19 8.73469C19 8.32893 19.3358 8 19.75 8Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 19.75C32 20.1642 31.6776 20.5 31.28 20.5L8.72 20.5C8.32236 20.5 8 20.1642 8 19.75C8 19.3358 8.32236 19 8.72 19L31.28 19C31.6776 19 32 19.3358 32 19.75Z"
      class="fill-current"
    />
  </svg>
</template>
